<!-- 文件标签 -->
<template>
  <div>
    <!-- 搜索区域 -->
    <div class="searchBox">
      <div class="userNameSearch">
        <div class="searchTxt">标签名称</div>
        <el-input
          placeholder="请输入标签名称"
          size="medium"
          v-model="queryTag.mtagName"
          @change="getTag()"
          clearable
        >
        </el-input>
      </div>
    </div>

    <!-- 卡片区域 -->
    <el-card class="right-card">
      <!-- 增加标签按钮 -->
      <el-button
        icon="el-icon-plus"
        type="primary"
        size="small"
        class="add-btn"
        plain
        @click="AddTagDialogVisible = true"
      >
        新增
      </el-button>
      <!-- 角色信息表格区域 -->
      <el-table
        :data="roleList"
        :header-cell-style="{
          background: '#0395d9',
          color: '#505255',
          textAlign: 'center',
        }"
        :cell-style="{ color: '#4d5a6a', textAlign: 'center' }"
      >
        <el-table-column prop="mtagName" label="标签名称" min-width="20%">
          <!-- 标签：  0标识info(灰色),  1标识danger(红色),2标识warning(黄色),3标识success(绿色),4标识(蓝色),-->
          <template v-slot="mtagNameSlot">
            <el-tag
              effect="dark"
              v-if="mtagNameSlot.row.mtagAttribute === 0"
              type="info"
              >{{ mtagNameSlot.row.mtagName }}</el-tag
            >

            <el-tag
              effect="dark"
              v-if="mtagNameSlot.row.mtagAttribute === 1"
              type="danger"
              >{{ mtagNameSlot.row.mtagName }}</el-tag
            >
            <el-tag
              effect="dark"
              v-if="mtagNameSlot.row.mtagAttribute === 2"
              type="warning"
              >{{ mtagNameSlot.row.mtagName }}</el-tag
            >
            <el-tag
              effect="dark"
              v-if="mtagNameSlot.row.mtagAttribute === 3"
              type="success"
              >{{ mtagNameSlot.row.mtagName }}</el-tag
            >
            <el-tag effect="dark" v-if="mtagNameSlot.row.mtagAttribute === 4">{{
              mtagNameSlot.row.mtagName
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="mtagCreateTime" label="创建时间">
        </el-table-column>
        <el-table-column label="操作" width="130">
          <template v-slot="slot">
            <el-tooltip
              class="item"
              effect="dark"
              content="修改"
              placement="bottom-start"
            >
              <el-button
                type="warning"
                size="small"
                circle
                icon="el-icon-edit"
                @click="openEditDialog(slot.row)"
              ></el-button>
            </el-tooltip>
            <el-tooltip
              class="item"
              content="删除"
              placement="bottom-start"
              effect="dark"
            >
              <el-button
                type="danger"
                size="small"
                circle
                icon="el-icon-delete"
                @click="deleteTag(slot.row)"
              ></el-button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="queryTag.page"
        :page-sizes="[10, 20, 30, 40, 50]"
        :page-size="queryTag.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      >
      </el-pagination>
    </el-card>

    <!-- 添加标签信息对话框 -->
    <el-dialog
      title="新增标签"
      :visible.sync="AddTagDialogVisible"
      width="50%"
      height="80%"
      :close-on-click-modal="false"
      @close="clearAddTagDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addTagFormRef"
        :rules="AddTagRules"
        :model="addTagInfo"
        label-width="80px"
      >
        <el-form-item prop="mtagName" label="标签名称">
          <el-input
            placeholder="请输入标签名称"
            v-model="addTagInfo.mtagName"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="mtagAttribute" label="标签颜色">
          <!-- 标签：  0标识info(灰色),  1标识danger(红色),2标识warning(黄色),3标识success(绿色),4标识(蓝色),-->
          <el-radio-group v-model="addTagInfo.mtagAttribute">
            <el-radio :label="0"><el-button type="info"></el-button></el-radio>
            <el-radio :label="1"
              ><el-button type="danger"></el-button
            ></el-radio>
            <el-radio :label="2"
              ><el-button type="warning"></el-button
            ></el-radio>
            <el-radio :label="3"
              ><el-button type="success"></el-button
            ></el-radio>
            <el-radio :label="4">
              <el-button type="primary"></el-button
            ></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AddTagDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="addTag()">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 修改标签信息对话框 -->
    <el-dialog
      title="修改标签"
      :visible.sync="EditTagDialogVisible"
      width="50%"
      :close-on-click-modal="false"
      @close="clearAddTagDialogVisible()"
    >
      <!-- 表单区域 -->
      <el-form
        ref="addTagFormRef"
        :rules="AddTagRules"
        :model="editTagInfo"
        label-width="80px"
      >
        <el-form-item prop="mtagName" label="标签名称">
          <el-input
            placeholder="请输入标签名称"
            v-model="editTagInfo.mtagName"
            clearable
          >
          </el-input>
        </el-form-item>

        <el-form-item prop="mtagAttribute" label="标签颜色">
          <!-- 标签：  0标识info(灰色),  1标识danger(红色),2标识warning(黄色),3标识success(绿色),4标识(蓝色),-->
          <el-radio-group v-model="editTagInfo.mtagAttribute">
            <el-radio :label="0"><el-button type="info"></el-button></el-radio>
            <el-radio :label="1"
              ><el-button type="danger"></el-button
            ></el-radio>
            <el-radio :label="2"
              ><el-button type="warning"></el-button
            ></el-radio>
            <el-radio :label="3"
              ><el-button type="success"></el-button
            ></el-radio>
            <el-radio :label="4">
              <el-button type="primary"></el-button
            ></el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="EditTagDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="editTag()">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      // 标签信息
      roleList: [],
      // 总数量
      total: 0,
      // 查询标签信息
      queryTag: {
        // 标签名称
        mtagName: "",
        //  当前页
        page: 1,
        //  每页显示多少条
        pageSize: 10,
      },
      // 控制添加标签的显示与隐藏
      AddTagDialogVisible: false,

      // 添加标签信息
      addTagInfo: {
        // 标签名称
        mtagName: "",
        // 标签颜色
        mtagAttribute: 0,
      },

      // 控制修改标签对话框的显示和隐藏
      EditTagDialogVisible: false,
      // 修改标签信息
      editTagInfo: {
        // 标签名称
        mtagName: "",
        // 标签颜色
        mtagAttribute: "",
        // 标签id
        mtagId: "",
      },
      // 添加标签验证规则
      AddTagRules: {
        mtagName: [
          { required: true, message: "请输入标签名称", trigger: "blur" },
        ],
      },
    };
  },
  mounted() {
    this.getTag();
  },
  methods: {
    // 获取标签信息
    async getTag() {
      const { data: res } = await this.$axios.get(
        `${this.$api}/media/tag/search`,
        {
          params: this.queryTag,
        }
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }
      this.roleList = res.data.rows;
      this.total = res.data.total;
    },
    // 当每页显示条发生改变时触发
    handleSizeChange(size) {
      this.queryTag.pageSize = size;
      this.getTag();
    },
    // 当当前页发生改变时触发
    handleCurrentChange(current) {
      this.queryTag.page = current;
      this.getTag();
    },

    // 关闭添加标签对话框时触发
    clearAddTagDialogVisible() {
      this.$refs.addTagFormRef.resetFields();
      this.$refs.addTagFormRef.clearValidate();
      // 修改标签信息
      this.editTagInfo.mtagName = "";
      this.editTagInfo.mtagAttribute = "";
      this.mtagId = "";
    },

    // 新增标签
    addTag() {
      this.$refs.addTagFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.post(
          `${this.$api}/media/tag/add`,
          {
            mtagName: this.addTagInfo.mtagName,
            mtagAttribute: this.addTagInfo.mtagAttribute,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.$message.success("新增标签成功");
        this.getTag();
        this.AddTagDialogVisible = false;
      });
    },

    // 打开修改对话框
    openEditDialog(data) {
      this.editTagInfo.mtagName = data.mtagName;
      this.editTagInfo.mtagAttribute = data.mtagAttribute;
      this.EditTagDialogVisible = true;
      this.editTagInfo.mtagId = data.mtagId;
    },

    // 修改标签信息
    async editTag() {
      this.$refs.addTagFormRef.validate(async (valid) => {
        if (!valid) return;
        const { data: res } = await this.$axios.put(
          `${this.$api}/media/tag/modfiy/` + this.editTagInfo.mtagId,
          {
            mtagName: this.editTagInfo.mtagName,
            mtagAttribute: this.editTagInfo.mtagAttribute,
          }
        );
        if (res.status != 0) {
          return this.$message.error(res.msg);
        }
        this.EditTagDialogVisible = false;
        this.$message.success("修改标签成功");
        this.getTag();
      });
    },

    // 删除标签信息
    async deleteTag(value) {
      const confirmVal = await this.$confirm(
        "此操作将永久删除该标签,删除后关联文件标签将取消,是否继续?",
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).catch((err) => err);
      if (confirmVal != "confirm") {
        return this.$message.info("已取消删除");
      }
      const { data: res } = await this.$axios.delete(
        `${this.$api}/media/tag/delete/` + value.mtagId
      );
      if (res.status != 0) {
        return this.$message.error(res.msg);
      }

      // 解决element分页删除最后一页的最后一条数据以后不会跳转到前一页
      // 解决思路：判断被删除的数据是否为最后一页的最后一条数据、如果是则让页码减一，如果不是则在当前面即可
      // math.ceil向上取整
      let lastPage = Math.ceil(this.total / this.queryTag.pageSize); //总数除以每页记录数
      // 判断当前页是否是最后一页 且 为最后一条数据
      if (
        this.queryTag.page === lastPage &&
        this.total % this.queryTag.pageSize === 1
      ) {
        this.queryTag.page--; //页码-1
      }

      this.$message.success("已成功删除该标签");
      this.getTag();
    },
  },
};
</script>


<style lang="less" scoped>
/* 新增按钮 */
.add-btn {
  float: left;
  margin-bottom: 10px;
}

.el-select {
  width: 100%;
}

.box-card {
  height: 400px !important;
  overflow: auto;
  margin: 0;
}

// el-dialog高度自适应，内容超出时中间出现滚动条
.common-dialog {
  display: flex;
  justify-content: center;
  align-items: Center;
  overflow: hidden;
  .el-dialog {
    margin: 0 auto !important;
    position: relative;
    .el-dialog__header {
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      width: 100%;
      height: 60px;
      z-index: 1;
    }
    .el-dialog__body {
      width: 100%;
      overflow: hidden;
      overflow-y: auto;
      max-height: 90vh; //最大高度为视口高度的90%
      padding-top: 80px;
      padding-bottom: 100px;
      z-index: 1;
    }
    .el-dialog__footer {
      position: absolute;
      left: 0;
      bottom: 0;
      right: 0;
      width: 100%;
      height: 80px;
      z-index: 1;
    }
  }
}

.searchBox {
  border-bottom: 1px solid #0693c0;
  margin: 0 0 5px 0;
  height: 50px;
  width: 100%;
  display: flex;
  align-content: center;
  // 用户名搜索区域
  .userNameSearch {
    width: 300px;
    display: flex;
    align-items: center;
    margin-left: 30px;

    // 搜索标题
    .searchTxt {
      color: #0693c0;
      font-weight: bold;
      width: 150px;
    }
    /* element-input背景颜色改为透明，修改输入字体颜色 */
    /deep/ .el-input__inner {
      background-color: transparent;
      color: #0693c0;
      margin: 15px 0;
      border: 1px solid #0693c0;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Main/EvidenceCenter/tag.vue